import { Text } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const breadcumbItemNormalStyle = {
  // color: 'primaryColor',
};

const breadcumbItemSelectedStyle = {
  color: 'primaryColor',
  // fontFamily: 'Primary Bold',
  fontWeight: 'bold',
};

type Props = {
  path: string;
  label: string;
  selected: boolean;
  disabled?: boolean;
};

const BreadcrumbItem = ({ path, label, selected, disabled = false }: Props) => {
  const itemRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (selected && itemRef && itemRef.current) {
      (itemRef.current as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [itemRef, selected, path]);

  const content = (
    <Text
      ref={itemRef}
      whiteSpace="nowrap"
      fontSize="sm"
      sx={selected ? breadcumbItemSelectedStyle : breadcumbItemNormalStyle}
    >
      {label}
    </Text>
  );

  if (disabled) return content;
  return <Link to={path}>{content}</Link>;
};

export default BreadcrumbItem;
